export const leadFieldConfiguration = [
  {
    name: "company",
    label: "Company",
    type: "text",
    validation: {
      required: "Company name is required",
    },
  },
  {
    name: "city",
    label: "City",
    type: "text",
    validation: {
      required: "City is required",
    },
  },
  {
    name: "dot",
    label: "DOT",
    type: "text",
    validation: {
      required: "DOT is required",
    },
  },
  {
    name: "mc",
    label: "MC",
    type: "text",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "New Lead", value: "New Lead" },
      { label: "Contacted", value: "Contacted" },
      { label: "Interested", value: "Interested" },
      { label: "Negotiating", value: "Negotiating" },
      { label: "Closed", value: "Closed" },
    ],
    validation: {
      required: "Status is required",
    },
  },
  {
    name: "assignedTo",
    label: "Assign To",
    type: "select",
    options: [{ label: "Steve Hoffmann", value: "Steve Hoffmann" }],
  },
  {
    name: "contactMethod",
    label: "Contact Method",
    type: "select",
    options: [
      { label: "Select", value: "" },
      { label: "Phone", value: "PHONE" },
      { label: "Email", value: "EMAIL" },
      { label: "Phone and Email", value: "PHONE AND EMAIL" },
    ],
  },
  {
    name: "contactedDate",
    label: "Contacted Date",
    type: "date",
  },
  {
    name: "interestedIn",
    label: "Interested In",
    type: "text",
  },
  {
    name: "isWarm",
    label: "Is Warm",
    type: "select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
];

export const leadInitialValues = {
  company: "",
  city: "",
  dot: "",
  mc: null,
  status: "",
  assignedTo: "Steve Hoffmann",
  contactMethod: "",
  contactedDate: null,
  interestedIn: null,
  isWarm: false,
};

export const updateLeadFieldConfiguration = [
  {
    name: "company",
    label: "Company",
    type: "text",
    validation: {
      required: "Company name is required",
    },
  },
  {
    name: "city",
    label: "City",
    type: "text",
    validation: {
      required: "City is required",
    },
  },
  {
    name: "dot",
    label: "DOT",
    type: "text",
    validation: {
      required: "DOT is required",
    },
  },
  {
    name: "mc",
    label: "MC",
    type: "text",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "New Lead", value: "New Lead" },
      { label: "Contacted", value: "Contacted" },
      { label: "Not interested", value: "Not interested" },
      { label: "Interested", value: "Interested" },
      { label: "Negotiating", value: "Negotiating" },
      { label: "Closed", value: "Closed" },
    ],
  },
  {
    name: "assignedTo",
    label: "Assign To",
    type: "select",
    options: [{ label: "Steve Hoffmann", value: "Steve Hoffmann" }],
  },
  {
    name: "contactMethod",
    label: "Contact Method",
    type: "select",
    options: [
      { label: "Select", value: "" },
      { label: "Phone", value: "PHONE" },
      { label: "Email", value: "EMAIL" },
      { label: "Phone and Email", value: "PHONE AND EMAIL" },
    ],
  },
  {
    name: "contactedDate",
    label: "Contacted Date",
    type: "date",
  },
  {
    name: "interestedIn",
    label: "Interested In",
    type: "text",
  },
  {
    name: "isWarm",
    label: "Is Warm",
    type: "select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
];
